@if (isOpen()) {
<div
  class="modal-backdrop fixed inset-0 flex items-center justify-center z-50 transition-all duration-300 ease-out"
  [class.bg-gray-950/50]="isAnimating()"
  [class.bg-gray-950/0]="!isAnimating()"
  (click)="closeModal()"
>
  <div
    class="modal-container bg-white rounded-lg shadow-xl w-full max-w-sm sm:max-w-md lg:max-w-2xl xl:max-w-4xl mx-4 sm:mx-6 lg:mx-8 transform transition-all duration-300 ease-out overflow-hidden"
    [class.scale-100]="isAnimating()"
    [class.opacity-100]="isAnimating()"
    [class.scale-95]="!isAnimating()"
    [class.opacity-0]="!isAnimating()"
    [class.translate-y-0]="isAnimating()"
    [class.translate-y-4]="!isAnimating()"
    (click)="$event.stopPropagation()"
  >
    <div class="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200">
      <h3 class="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">Solicitar Reclamo</h3>
      <button
        (click)="closeModal()"
        class="text-gray-400 hover:text-gray-600 transition-colors p-1 sm:p-2"
      >
        <i class="fas fa-times text-lg sm:text-xl"></i>
      </button>
    </div>

    <form
      [formGroup]="claimForm"
      class="p-4 sm:p-6 overflow-y-auto max-h-[70vh] sm:max-h-[80vh]"
      (ngSubmit)="OnSendClaim()"
    >
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 lg:gap-6">
        <!-- Columna izquierda: selector de reclamo -->
        <div class="w-full sm:w-1/2 space-y-4">
          <select-claim (selectedClaimChange)="onSelectClaim($event)"></select-claim>
           <div class="flex flex-col gap-2">
            <label for="claim-description" class="text-sm font-medium text-gray-700">Descripción del reclamo</label>
            <textarea
              id="claim-description"
              rows="5"
              minlength="10"
              formControlName="description"
              class="w-full resize-none rounded-md border border-gray-300 bg-white text-gray-700 text-sm shadow-sm px-3.5 py-2.5 focus:border-amber-500 focus:ring focus:ring-amber-200 focus:ring-opacity-50 transition-colors"
              placeholder="Describe brevemente el problema..."
            ></textarea>
            <p class="text-xs text-gray-500">Explica lo ocurrido y qué esperas como solución.</p>
          </div>
        </div>

        <!-- Columna derecha: campos adicionales -->
        <div class="w-full sm:w-1/2 space-y-4">
          <!-- Descripción del reclamo -->


          <!-- Imagen opcional -->
          <div class="flex flex-col gap-2">
            <label for="claim-image" class="text-sm font-medium text-gray-700">Adjuntar imagen </label>
            <input
              type="file"
              id="claim-image"
              accept="image/png, image/jpeg, image/jpg"
              (change)="onImageSelected($event)"
              class="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100 border border-gray-300 rounded-md"
            />
            @if (imagePreview()) {
              <div class="mt-2 rounded-md border border-gray-200 overflow-hidden">
                <img [src]="imagePreview()!" alt="Previsualización de imagen" class="w-full h-40 object-cover" />
              </div>
            }

          </div>

        </div>
      </div>

      <!-- Acciones -->
      <div class="w-full flex justify-end gap-2 sm:gap-3 border-t border-gray-200 mt-4 pt-4">
        <button
          type="button"
          (click)="closeModal()"
          class="inline-flex items-center justify-center h-10 px-4 rounded-md border border-gray-300 bg-white text-gray-700 text-sm font-medium shadow-sm hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
        <button
          [disabled]="claimForm.invalid"
          type="submit"
          class="cursor-pointer inline-flex items-center justify-center h-10 px-4 rounded-md bg-amber-500 text-white text-sm font-medium shadow-sm hover:bg-amber-600 focus:ring focus:ring-amber-200 focus:ring-opacity-50 transition-colors disabled:bg-amber-300 disabled:text-white disabled:opacity-60 disabled:cursor-not-allowed disabled:shadow-none disabled:hover:bg-amber-300 disabled:focus:ring-0"
        >
          Enviar reclamo
        </button>
      </div>
    </form>
  </div>
</div>
}

<app-loader-subito></app-loader-subito>
